<div class="side-by-side-tabs position-relative">
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
  <div class="panel-title">{{ Messages.KBASE_UPLOAD_FORM_TITLE }}</div>
  <mat-tab-group [formGroup]="uploadForm" [selectedIndex]="selectedIndex" (selectedTabChange)="onTabChange($event)"
    class="-mat-tab-list-d-flex">
    <mat-tab label="Generic Details">
      <ng-template mat-tab-label>
        <div class="mat-tab-label-content">Details</div>
        <mat-icon class="material-icons red-color" *ngIf="isUploadFormSubmitted && (uploadForm.get('title').invalid ||
        uploadForm.get('area').invalid || uploadForm.get('category').invalid)">highlight_off</mat-icon>
      </ng-template>
      <div class="make-responsive">
        <div class="mt-top-2 field">
          <mat-form-field>
            <mat-label>Title</mat-label>
            <input matInput formControlName="title">
            <ng-container *ngIf="uploadForm.get('title')?.errors">
              <mat-error *ngIf="isUploadFormSubmitted && uploadForm.get('title')?.errors['required']">
                <em class="fas fa-exclamation-circle mr-2"></em>{{ Messages?.KBASE_UPLOAD_FORM_TITLE_REQUIRED }}
              </mat-error>
            </ng-container>
          </mat-form-field>
        </div>
        <div class="mt-top-2 field">
          <mat-form-field>
            <mat-label>Area</mat-label>
            <mat-select [disableOptionCentering]="true" formControlName="area">
              <mat-option class="text-capitalize" *ngFor="let option of areaList" [value]="option" selected>
                {{ option | titlecase }}
              </mat-option>
            </mat-select>
            <ng-container *ngIf="uploadForm.get('area')?.errors">
              <mat-error *ngIf="isUploadFormSubmitted && uploadForm.get('area')?.errors['required']">
                <em class="fas fa-exclamation-circle mr-2"></em>{{ Messages?.KBASE_UPLOAD_FORM_AREA_REQUIRED }}
              </mat-error>
            </ng-container>
          </mat-form-field>
        </div>
        <div class="mt-top-2 field">
          <mat-form-field>
            <mat-label>Tags</mat-label>
            <input matInput formControlName="hashtag">
          </mat-form-field>
        </div>
        <div class="mt-top-2 field">
          <mat-form-field>
            <mat-label>Category</mat-label>
            <mat-select [disableOptionCentering]="true" formControlName="category">
              <mat-option class="text-capitalize" *ngFor="let option of categoryList" [value]="option" selected>
                {{ option | titlecase }}
              </mat-option>
            </mat-select>
            <ng-container *ngIf="uploadForm.get('category')?.errors">
              <mat-error *ngIf="isUploadFormSubmitted && uploadForm.get('category')?.errors['required']">
                <em class="fas fa-exclamation-circle mr-2"></em>{{ Messages?.KBASE_UPLOAD_FORM_CATEGORY_REQUIRED }}
              </mat-error>
            </ng-container>
          </mat-form-field>
        </div>
        <div class="mt-top-2 field">
          <mat-form-field>
            <mat-label>Author</mat-label>
            <input matInput formControlName="author">
          </mat-form-field>
        </div>
        <div class="mt-top-2 field">
          <mat-form-field>
            <mat-label>Estimated Time</mat-label>
            <input matInput formControlName="estimatedTime">
          </mat-form-field>
        </div>
      </div>
      <div class="-text-area-field-height">
      <mat-form-field>
        <mat-label>Description</mat-label>
        <textarea matInput formControlName="description"></textarea>
      </mat-form-field>
      </div>
      <div class="btn-basket">
        <button mat-raised-button color="primary" (click)="onStepChange('next')">
          <img class=" w-100 h-30 image-container" alt="" src="../../assets/images/next-arrow.svg" />
        </button>
      </div>
    </mat-tab>

    <mat-tab label="Upload">
      <ng-template mat-tab-label>
        <div class="mat-tab-label-content">Attach File</div>
        <mat-icon class="material-icons red-color"
          *ngIf="isUploadFormSubmitted && (uploadForm.get('file').invalid || uploadForm.get('thumbnail').invalid)">
          highlight_off</mat-icon>
      </ng-template>
      <div class="d-grid g-gap10">

        <div class="w-100 d-flex flex-column justify-content-center align-items-center ">
          <div class="d-flex flex-column fit-content">
            <div class="d-flex">
              <h5>File</h5>
              <div class="position-relative ml-auto "> <img class=" w-100 h-30 image-container showhim" alt="info"
                  src="../../assets/images/info-ico.svg" />
                <div class="kb-file-type-displaystyle showme"><span>Select a file in </span><span
                    class="kb-file-type-style">{{ Messages?.KBASE_UPLOAD_FORM_FILE_VALID_EXTENSION }}</span></div>
              </div>
            </div>
            <app-file formControlName="file" [content]="fileContent?.file" [folder]="'documents'"
              [image]="'kb_defaultfile.svg'" [isFileTypeImage]="true" [requiredFileSize]="maxFileSize"
              [requiredFileType]="fileMimeTypes" [startUpload]="startFileBlobUpload"
              (uploadResponse)="uploadResponse($event, 'file')">
            </app-file>
            <ng-container *ngIf="uploadForm.get('file')?.errors">
              <mat-error class="lh-30" *ngIf="isUploadFormSubmitted && uploadForm.get('file')?.errors['required']">
                <em class="fas fa-exclamation-circle mr-2"></em>{{ Messages?.KBASE_UPLOAD_FORM_FILE_REQUIRED }}
              </mat-error>
              <mat-error class="lh-30" *ngIf="uploadForm.get('file')?.errors['requiredFileSize']">
                <em class="fas fa-exclamation-circle mr-2"></em>{{ Messages?.KBASE_UPLOAD_FORM_FILE_INVALID_SIZE |
                replace: '[SIZE]': (maxFileSize | filesize) }}
              </mat-error>
              <mat-error class="lh-30" *ngIf="uploadForm.get('file')?.errors['requiredFileType']">
                <em class="fas fa-exclamation-circle mr-2"></em>{{ Messages?.KBASE_UPLOAD_FORM_FILE_INVALID_TYPE }}
              </mat-error>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="d-grid g-gap10">

        <div class="w-100 d-flex flex-column justify-content-center align-items-center ">
          <div class="d-flex flex-column fit-content">
            <div class="d-flex">
              <h5>Thumbnail</h5>
              <div class="position-relative ml-auto"> <img class=" w-100 h-30 image-container showhim" alt="info"
                  src="../../assets/images/info-ico.svg" />
                <div class="kb-file-type-displaystyle showme"><span>Select a thumbnail </span><Span
                    class="kb-file-type-style">{{ Messages?.KBASE_UPLOAD_FORM_THUMBNAIL_VALID_EXTENSION }}</Span></div>
              </div>
            </div>
            <app-file formControlName="thumbnail" [content]="fileContent?.thumbnail" [folder]="'documents'"
              [image]="'kb_defaultthumbnail.svg'" [isFileTypeImage]="false" [requiredFileSize]="maxThumbnailSize"
              [requiredFileType]="thumbnailMimeTypes" [startUpload]="startThumbnailBlobUpload"
              (uploadResponse)="uploadResponse($event, 'thumbnail')">
            </app-file>
            <ng-container *ngIf="uploadForm.get('thumbnail')?.errors">
              <mat-error class="lh-30" *ngIf="uploadForm.get('thumbnail')?.errors['requiredFileSize']">
                <em class="fas fa-exclamation-circle mr-2"></em>{{ Messages?.KBASE_UPLOAD_FORM_THUMBNAIL_INVALID_SIZE |
                replace: '[SIZE]': (maxThumbnailSize | filesize) }}
              </mat-error>
              <mat-error class="lh-30" *ngIf="uploadForm.get('thumbnail')?.errors['requiredFileType']">
                <em class="fas fa-exclamation-circle mr-2"></em>{{ Messages?.KBASE_UPLOAD_FORM_THUMBNAIL_INVALID_TYPE }}
              </mat-error>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="btn-basket">
        <button mat-raised-button color="primary" (click)="onStepChange('previous')">
          <img class=" w-100 h-30 image-container" alt="" src="../../assets/images/right-arrow.svg" />
        </button>
        <button mat-raised-button color="primary" (click)="onFormSubmit()">Submit</button>
      </div>
    </mat-tab>

  </mat-tab-group>
  <div class="red-color" style="text-align: center;">{{ errorMessage }}</div>
</div>